import {
  GET_DECLINE_REASON_REQ,
	GET_DECLINE_REASON_FAIL,
	GET_DECLINE_REASON_SUCCESS,
	SAVE_DECLINE_REASON_REQ,
	SAVE_DECLINE_REASON_SUCCESS,
	SAVE_DECLINE_REASON_FAIL
} from '../constants/declineReason';

export const declineReasonReducer = (state = {}, action) => {
	switch (action.type) {
		case GET_DECLINE_REASON_REQ:
			return { loading: true };
		case GET_DECLINE_REASON_SUCCESS:
			return { loading: false, declineReasons: action.payload };
		case GET_DECLINE_REASON_FAIL:
			return { loading: false, error: action.payload };
		case SAVE_DECLINE_REASON_REQ:
			return { ...state, loading: true };
		case SAVE_DECLINE_REASON_SUCCESS:
			return { loading: false, declineReasons: action.payload };
		case SAVE_DECLINE_REASON_FAIL:
			return { loading: false, error: action.payload };
		default:
			return state;
	}
};
